type Props = {
  className?: string;
  fill: string;
  height: string;
  stroke: string;
  width: string;
};

const FlagIcon = ({ stroke, width, height, fill, className }: Props) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 10 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className || ''}
      >
        <path
          d="M1 12.7704V1.5C1 1.22386 1.22386 1 1.5 1H8.5C8.77614 1 9 1.22386 9 1.5V12.7704C9 13.219 8.45494 13.4406 8.14188 13.1193L5.35811 10.2623C5.16186 10.0609 4.83814 10.0609 4.64189 10.2623L1.85811 13.1193C1.54506 13.4406 1 13.219 1 12.7704Z"
          fill={fill}
          stroke={stroke}
        />
      </svg>
    </>
  );
};

export default FlagIcon;
